<script>
    import LayoutGrid, {Cell as LayoutCell} from "@smui/layout-grid";
    import DataTable, {Body, Cell, Row} from "@smui/data-table";
    import Paper, {Subtitle, Title} from "@smui/paper";

    import NumberElt from "./Number.svelte";
    import Percent from "./Percent.svelte";
    import Currency from "./Currency.svelte";

    import {workingDays, globalState} from '../store/store.js';

    export let result = undefined;
    let firstName = null;
    let lastName = null;
    let monthYearStore = null;
    let monthYear = null;
    let currentDate = new Date();

    let portageFees = 0;
    let operatingExpenses = 0;
    let provisions = 0;
    let travellingExpenses = 0;
    let vacation = false;

    for (const [key, value] of Object.entries($globalState)) {
        if ('o' === key) {
            firstName = value;
        } else if ('p' === key) {
            lastName = value;
        } else if ('n' === key) {
            monthYearStore = value;
        } else if ('s' === key) {
            vacation = value
        }
    }

    if (monthYearStore) {
        let [year, month] = monthYearStore.split("-");
        let myDate = new Date(year, month - 1, 1);
        monthYear = new Intl.DateTimeFormat("fr-FR", {
            month: "long",
            year: "numeric"
        }).format(myDate);
    } else {
        monthYear = new Intl.DateTimeFormat('fr-FR', {month: 'long', year: 'numeric'}).format(currentDate);
    }
    monthYear = monthYear.charAt(0).toUpperCase() + monthYear.slice(1);

    if (result.portageFees > 0) {
        portageFees = result.portageFees * -1;
    }
    if (result.operatingExpenses > 0) {
        operatingExpenses = result.operatingExpenses * -1;
    }
    if (result.rawData.variables.provisions.value > 0) {
        provisions = result.rawData.variables.provisions.value * -1;
    }
    if (result.travellingExpenses > 0) {
        travellingExpenses = result.travellingExpenses * -1;
    }

    let disponible = result.invoiceAmount + portageFees + operatingExpenses + provisions + travellingExpenses;

    function getValue(result, key, period = "monthly") {
        let periodFactor = period === "yearly" && key !== "dailyRate" ? 12 : 1;
        return result[key] * periodFactor;
    }

    $: isDifferent = Number($workingDays) !== Number(result.daysPerMonth);

    //$: console.log("workingDays:", $workingDays, "result.daysPerMonth:", result.daysPerMonth);

    //let resizeObserver;
    //let canvas;

    const params = new URLSearchParams();

    for (const [key, value] of Object.entries($globalState)) {
        if (value !== null && value !== undefined) {
            params.append(key, value);
        }
    }

    const urlWork = `${window.location.origin + window.location.pathname}?${params.toString()}`;

</script>
<LayoutGrid style="padding: 0" id="id-print-extract">
    <LayoutCell span={12}>
        <Paper color="primary" variant="outlined" class="orange" style="text-align:center;font-weight:bold;">
            <LayoutGrid style="padding: 0">
                <LayoutCell span={12} class="resume-salary">
                    <span>Période : {monthYear}</span>
                    <br><br>
                    <span>Simulation pour l'adhérent</span>
                    {#if firstName || lastName}
                        <span>{firstName} {lastName}</span>
                    {/if}
                    <!--Nom Consultant-->
                    <br><br>

                    <span>Estimation mensuelle sur <NumberElt number={$workingDays}/> </span>
                    <!-- {#if isDifferent }
                        <span>(≃<NumberElt number={result.daysPerMonth} /> avec CP) </span>
                    {/if}-->
                    <span>jours </span>
                    <span> pour un TJM de <Currency number={getValue(result, "dailyRate")}/> </span>
                    {#if result.metadata.input.hasMutuelle}
                        <span>avec mutuelle et </span>
                    {:else}
                        <span>sans mutuelle et </span>
                    {/if}
                    {#if vacation}
                        <span>congé payés.</span>
                    {:else}
                        <span>congés provisionnés.</span>
                    {/if}
                </LayoutCell>
                <LayoutCell span={12} class="download">
                    <h3>CONCRETIO</h3>
                    <span>Période : {monthYear}</span>
                    <br><br>
                    <span>Simulation pour l'adhérent</span>
                    {#if firstName || lastName}
                        <span>{firstName} {lastName}</span>
                    {/if}
                    <!--Nom Consultant-->
                    <br><br>

                    <span>Estimation mensuelle sur <NumberElt number={$workingDays}/> </span>
                    <!-- {#if isDifferent }
                        <span>(≃<NumberElt number={result.daysPerMonth} /> avec CP) </span>
                    {/if}-->
                    <span>jours </span>
                    <span> pour un TJM de <Currency number={getValue(result, "dailyRate")}/> </span>
                    {#if result.metadata.input.hasMutuelle}
                        <span>avec mutuelle et </span>
                    {:else}
                        <span>sans mutuelle et </span>
                    {/if}
                    {#if vacation}
                        <span>congé payés.</span>
                    {:else}
                        <span>congés provisionnés.</span>
                    {/if}
                </LayoutCell>
                <LayoutCell span={8} class="no-web">
                    <h2>CONCRETIO</h2>
                    <span>Période : {monthYear}</span>
                    <br><br>
                    Simulation pour l'adhérent
                    {#if firstName || lastName}
                        <span>{firstName} {lastName}</span>
                    {/if}
                    <!--Nom Consultant-->
                    <br><br>

                    <span>Estimation mensuelle sur <NumberElt number={$workingDays}/> </span>
                    <!--{#if isDifferent }
                        <span>(≃<NumberElt number={result.daysPerMonth} /> avec CP) </span>
                    {/if}-->
                    <span>jours </span>
                    <span> pour un TJM de <Currency number={getValue(result, "dailyRate")}/> </span>
                    {#if result.metadata.input.hasMutuelle}
                        <span>avec mutuelle et </span>
                    {:else}
                        <span>sans mutuelle et </span>
                    {/if}
                    {#if vacation}
                        <span>congé payés.</span>
                    {:else}
                        <span>congés provisionnés.</span>
                    {/if}
                </LayoutCell>
            </LayoutGrid>
        </Paper>
    </LayoutCell>
    <LayoutCell span={12}>
        <DataTable table$aria-label="extract-one" style="width: 100%;">
            <Body>
            <Row>
                <Cell style="font-weight: bold;">Facturation HT</Cell>
                <Cell numeric style="text-align: right;font-weight: bold;">
                    <Currency number={getValue(result, "invoiceAmount")}/>
                </Cell>
            </Row>
            </Body>
        </DataTable>
    </LayoutCell>
    <LayoutCell span={12}>
        <DataTable table$aria-label="extract-two" style="width: 100%;">
            <Body>
            <Row>
                <Cell>Commission de portage en %</Cell>
                <Cell numeric style="text-align: right;">
                    <Percent number={getValue(result, "portageFeesRate")} subs=true withLog=true/>
                </Cell>
            </Row>
            <Row>
                <Cell>Commission de portage en valeur</Cell>
                <Cell numeric style="text-align: right;">
                    <Currency number={getValue(result, "portageFees")} subs=true withLog=true/>
                </Cell>
            </Row>
            <Row>
                <Cell>Frais de fonctionnement</Cell>
                <Cell numeric style="text-align: right;">
                    <Currency number={getValue(result, "operatingExpenses")} subs=true/>
                </Cell>
            </Row>
            <Row>
                <Cell>Provisions</Cell>
                <Cell numeric style="text-align: right;">
                    <Currency number={result.rawData.variables.provisions.value} subs=true/>
                </Cell>
            </Row>
            <Row>
                <Cell>Frais optimisables</Cell>
                <Cell numeric style="text-align: right;">
                    <Currency number={result.travellingExpenses} subs=true/>
                </Cell>
            </Row>
            </Body>
        </DataTable>
    </LayoutCell>
    <LayoutCell span={12}>
        <DataTable table$aria-label="extract-three" style="width: 100%;font-weight: bold;">
            <Body>
            <Row>
                <Cell style="font-weight: bold;">Disponible</Cell>
                <Cell numeric style="text-align: right;font-weight: bold;">
                    <Currency number={disponible}/>
                </Cell>
            </Row>
            </Body>
        </DataTable>
    </LayoutCell>
    <LayoutCell span={12}>
        <DataTable table$aria-label="extract-four" style="width: 100%;">
            <Body>
            <Row>
                <Cell>Salaire Brut</Cell>
                <Cell style="text-align: right;">
                    <Currency number={result.totalBaseGross}/>
                </Cell>
            </Row>
            <Row>
                <Cell>Charges Patronales</Cell>
                <Cell style="text-align: right;">
                    <Currency number={result.totalEmployerContributions}/>
                </Cell>
            </Row>
            <Row>
                <Cell>Charges Salariales</Cell>
                <Cell style="text-align: right;">
                    <Currency number={result.totalSalaryContributions}/>
                </Cell>
            </Row>
            <Row>
                <Cell style="font-weight: bold;">Salaire NET</Cell>
                <Cell style="text-align: right;font-weight: bold;">
                    <Currency number={result.netSalary}/>
                </Cell>
            </Row>
            </Body>
        </DataTable>
    </LayoutCell>
    <LayoutCell span={12}>
        <DataTable table$aria-label="extract-five" style="width: 100%;">
            <Body>
            <Row>
                <Cell>Remboursement de Frais</Cell>
                <Cell numeric style="text-align: right;">
                    <Currency number={result.travellingExpenses}/>
                </Cell>
            </Row>
            </Body>
        </DataTable>
    </LayoutCell>
    <LayoutCell span={12}>
        <DataTable table$aria-label="extract-six" style="width: 100%;">
            <Body>
            <Row>
                <Cell style="font-weight: bold;">Montant Net versé (Salaire + Frais)</Cell>
                <Cell numeric style="text-align: right;font-weight: bold;">
                    <Currency number={result.netToPayBeforePAS}/>
                </Cell>
            </Row>
            </Body>
        </DataTable>
    </LayoutCell>
</LayoutGrid>